import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { RoleService } from 'src/app/_services/role.service';
import { TokenPartner } from 'src/app/_types/partner.type';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { getInsuranceTypeLabel } from 'src/app/enums/insurance-type.enum';
import { PartnerType } from 'src/app/enums/partner.enums';
import {
  getPeriodicityLabel,
  getProposalStateBadgeClass,
  getProposalStateLabel,
  ProposalState,
} from 'src/app/enums/proposal.enums';
import { Roles } from 'src/app/enums/roles.enum';
import { Globals } from 'src/app/globals';
import { LanguageCode } from 'src/app/helpers/nationalities';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { ProposalProductsDisplayerComponent } from '../proposal-products-displayer/proposal-products-displayer.component';

@Component({
  selector: 'app-proposal-displayer',
  templateUrl: './proposal-displayer.component.html',
  styleUrls: ['./proposal-displayer.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    IconsModule,
    ProposalProductsDisplayerComponent,
    RouterModule,
  ],
})
export class ProposalDisplayerComponent implements OnInit, OnDestroy {
  @Input({ required: true }) offer!: ProposalDetails;

  @Input() showViewIcon = true;

  @Input() showActions = true;

  canEdit = false;

  private permissionSubscription?: Subscription;

  constructor(
    private readonly cookieService: CookieService,
    private readonly roleService: RoleService,
    private readonly globals: Globals
  ) {
    this.canEdit =
      (this.globals.getUser() as TokenPartner).userType === PartnerType.PARTNER;
  }

  ngOnInit(): void {
    if (!this.canEdit) {
      this.permissionSubscription = this.roleService
        .hasWritePermission(Roles.PROPOSALS)
        .subscribe({
          next: (hasWritePermission) => {
            this.canEdit = hasWritePermission;
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.permissionSubscription?.unsubscribe();
  }

  lngCode =
    (this.cookieService.get('selectedCountryCode') as LanguageCode) || 'fr';

  @Output() editProposal = new EventEmitter<ProposalDetails>();

  @Output() deleteProposal = new EventEmitter<string>();

  @Output() sendProposal = new EventEmitter<string>();

  @Output() viewDocument = new EventEmitter<string>();

  readonly ProposalState = ProposalState;

  readonly getProposalStateLabel = getProposalStateLabel;

  readonly getProposalStateBadgeClass = getProposalStateBadgeClass;

  readonly getInsuranceTypeLabel = getInsuranceTypeLabel;

  readonly getPeriodicityLabel = getPeriodicityLabel;
}
